export default "__VITE_ASSET__BuqgstGa__"